/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Go_Home_ButtonInputs */



/**
* | output |
* | --- |
* | "Go to Home" |
*
* @param {Offline_Go_Home_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_go_home_button = /** @type {((inputs?: Offline_Go_Home_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Go_Home_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à l'Accueil")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zur Startseite")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai alla Home")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти на главную страницу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir a Inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回首页")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ホームへ戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("होम पेज पर जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para a página inicial")
	return /** @type {LocalizedString} */ ("Go to Home")
});